import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { GoogleReCaptchaProvider } from "react-google-recaptcha-v3";

import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";

import env from "./constant/env.json";

// -------------------------------------
// Dynamic branding based on API URL
// -------------------------------------

const isDevApi = env.base_url === "https://devapi.naranel.com/api/";

// favicon
const favicon = document.getElementById("dynamic-favicon");

if (favicon) {
  favicon.href = isDevApi
    ? "/instructor_dev.ico"
    : "/instructor_production.ico";
}

// apple touch icon
const appleIcon = document.getElementById("dynamic-apple-icon");

if (appleIcon) {
  appleIcon.href = isDevApi ? "/logo192_dev.png" : "/logo192_production.png";
}

// manifest for installable PWA icon
const manifestLink = document.getElementById("dynamic-manifest");

if (manifestLink) {
  manifestLink.href = isDevApi
    ? "/manifest-dev.json"
    : "/manifest-production.json";
}

// -------------------------------------
// React App
// -------------------------------------

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <React.StrictMode>
    <GoogleReCaptchaProvider reCaptchaKey="6Lc2Qi4sAAAAAK38WhuJmsO2CFcG7sX-mf_fHXdm">
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </GoogleReCaptchaProvider>
  </React.StrictMode>,
);

reportWebVitals();
